import api from "./api";

function getErrorMessage(dataOrError, fallback) {
  const data = dataOrError?.response?.data ?? dataOrError;
  return (
    data?.getMessageText?.join(", ") ||
    data?.message?.[0]?.messageText ||
    dataOrError?.message ||
    fallback
  );
}

/**
 * Fetch list of provinces
 * @returns {Promise<Array<{ id: number, name: string }>>}
 */
export async function getProvinces() {
  try {
    const { data } = await api.get("/client/province/provinces");

    if (!data.isSuccessful) {
      throw new Error(getErrorMessage(data, "دریافت لیست استان‌ها ناموفق بود"));
    }

    return Array.isArray(data.data) ? data.data : [];
  } catch (error) {
    if (error.response) {
      throw new Error(getErrorMessage(error, "دریافت لیست استان‌ها ناموفق بود"));
    }
    throw error;
  }
}

/**
 * Fetch cities for a province
 * @param {number} provinceId
 * @returns {Promise<Array<{ id: number, name: string }>>}
 */
export async function getCities(provinceId) {
  try {
    const { data } = await api.get("/client/province/cities", {
      params: { provinceId },
    });

    if (!data.isSuccessful) {
      throw new Error(getErrorMessage(data, "دریافت لیست شهرها ناموفق بود"));
    }

    return Array.isArray(data.data) ? data.data : [];
  } catch (error) {
    if (error.response) {
      throw new Error(getErrorMessage(error, "دریافت لیست شهرها ناموفق بود"));
    }
    throw error;
  }
}
